/* eslint-disable jsx-a11y/interactive-supports-focus */

import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { handleExternalLinkClick } from '../helpers/url-helper';

export interface Props {
    content: string;
    className?: string;
}

export function Wysiwyg(props: Props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
        handleExternalLinkClick(e, dispatch, history, location);
    };

    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.content }}
            className={`rich-text ${props.className}`}
            onClick={(e) => handleContentClick(e)}
            role='link'
            onKeyPress={() => { }}
            aria-label='cms-content'
        />);
}

Wysiwyg.defaultProps = {
    className: '',
};